import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/store';
import { ChevronRight, ChevronLeft } from 'lucide-react';

import { PrimaryButton, SecondaryButton } from 'src/shared/components/button/Button';
import styles from './BottomNavigation.module.scss';
import { setCurrentStep } from '../../state/newSurveyDesignSlice';
import { getCurrentSurveyDesignFormStep } from '../../state/newSurveyDesignSelector';
import useSurveyDesign from '../../hooks/useSurveyDesign';

const BottomNavigation = () => {
    const dispatch = useAppDispatch();
    const formStep = useAppSelector(getCurrentSurveyDesignFormStep);

    const { hasCompletedCurrentStep } = useSurveyDesign();
    const onStepChange = (step: number) => {
        dispatch(setCurrentStep(step));
    };

    return (
        <div className={styles.bottomNavigation}>
            <SecondaryButton onClick={() => onStepChange(formStep - 1)} disabled={formStep === 0}>
                <ChevronLeft /> Back
            </SecondaryButton>

            <PrimaryButton onClick={() => onStepChange(formStep + 1)} disabled={!hasCompletedCurrentStep()}>
                Next <ChevronRight />
            </PrimaryButton>
        </div>
    );
};

export default BottomNavigation;
